import vuewidget from '@/helpers/vuewidget'
import Co2Calculator from '@/components/Co2Calculator.vue'

export default function (dom, opts) {
  // eslint-disable-next-line no-unused-vars
  const widget = vuewidget(dom, {
    vueComponent: Co2Calculator,
    vueInit: 'initGlobal',
    ...opts
  })
}
